<template>
    <div>
        <ListPage
            :query="query"
            :total="total"
            v-loading="loading"
            :data="tableData"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            @search="handleSearch"
            @reset="resetQuery"
        >
            <template slot="filters">
                <el-form-item label="" prop="search_keyword">
                    <el-input v-model="query.search_keyword" placeholder="输入标签名称进行检索" clearable @keyup.enter.native="handleSearch" />
                </el-form-item>
            </template>
            <template slot="btns" v-if="permission('hygl_bqgl_xz')">
                <el-button style="margin-left: 10px" size="mini" type="primary" @click="handleAdd"> 新增 </el-button>
            </template>
            <template slot="columns">
                <el-table-column label="排序" align="center" type="index" width="80" />
                <el-table-column label="标签名称" align="center" prop="name" />
                <el-table-column label="人数" align="center" prop="user_number" />
                <el-table-column label="创建时间" align="center" prop="create_time" />
                <el-table-column label="操作" align="center" width="180">
                    <template slot-scope="{ row }">
                        <el-button v-if="permission('hygl_bqgl_ckglyh')" size="mini" type="text" @click="handleDetail(row)"> 查看关联用户 </el-button>
                        <el-button v-if="permission('hygl_bqgl_bj')" size="mini" type="text" @click="handleEdit(row)"> 编辑 </el-button>
                        <el-button v-if="permission('hygl_bqgl_sc')" size="mini" type="text" @click="handleDel(row)"> 删除 </el-button>
                    </template>
                </el-table-column>
            </template>
        </ListPage>
        <Popup ref="popup" @update="search"></Popup>
    </div>
</template>

<script>
import { list, del } from "@/api/member/tag";
import listMixin from "@/mixins/list";
import Popup from "./popup.vue";

export default {
    components: { Popup },
    data() {
        return {
            list,
            del,
            // 查询参数
            query: {
                search_keyword: "",
            },
            module: "标签",
            detailPath: "/member/user",
        };
    },
    mixins: [listMixin],
    mounted() {
        this.search();
    },
    methods: {
        search() {
            this._search();
        },
        handleAdd() {
            this.$refs.popup.open();
        },
        handleEdit(row) {
            this.$refs.popup.open(row.uuid);
        },
    },
};
</script>
